class ProductMediaZoom {
  constructor() {
    this.images = [];
    this.currentIndex = 0;
    this.overlay = null;
    this.scrollContainer = null;
    this.isOpen = false;

    this.init();
  }

  init() {
    this.createOverlay();
    this.bindGalleryClicks();
    this.setCursor();
  }

  createOverlay() {
    const el = document.createElement('div');
    el.className = 'pmz-overlay';

    el.innerHTML = `
      <button class="pmz-close" aria-label="Close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
      <div class="pmz-scroll-container"></div>
    `;

    document.body.appendChild(el);

    this.overlay = el;
    this.scrollContainer = el.querySelector('.pmz-scroll-container');

    el.querySelector('.pmz-close').addEventListener('click', () => this.close());

    this.scrollContainer.addEventListener('click', (e) => {
      if (e.target === this.scrollContainer) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.isOpen) return;
      if (e.key === 'Escape') this.close();
    });
  }

  /* --------------------------
     Collect images (DESKTOP)
  ---------------------------*/

  collectImages() {
    const gallery = document.querySelector('product-media-gallery');
    if (!gallery) return [];

    const mainSlider = gallery.querySelector('[data-ref="main-slider"]');
    if (!mainSlider) return [];

    const slides = mainSlider.querySelectorAll('.splide__slide.product-media-gallery__media');
    const images = [];

    slides.forEach((slide) => {
      const img = slide.querySelector('.product-media img');
      if (!img) return;

      let src = img.src;

      if (img.srcset) {
        const parts = img.srcset.split(',').map(s => s.trim().split(/\s+/));
        let maxW = 0;

        parts.forEach(([url, w]) => {
          const width = parseInt(w);
          if (!isNaN(width) && width > maxW) {
            maxW = width;
            src = url;
          }
        });
      }

      src = src.replace(/[?&]width=\d+/, (m) => m.replace(/\d+/, '2000'));

      images.push({
        src,
        alt: img.alt || '',
        slideEl: slide
      });
    });

    return images;
  }

  /* --------------------------
     Collect images (MOBILE)
  ---------------------------*/

  // collectImagesFromSwiper() {
  //   const slides = document.querySelectorAll('.msw-main-slide img');
  //   const images = [];

  //   slides.forEach((img) => {

  //     let src = img.src;

  //     if (img.srcset) {
  //       const parts = img.srcset.split(',').map(s => s.trim().split(/\s+/));
  //       let maxW = 0;

  //       parts.forEach(([url, w]) => {
  //         const width = parseInt(w);
  //         if (!isNaN(width) && width > maxW) {
  //           maxW = width;
  //           src = url;
  //         }
  //       });
  //     }

  //     src = src.replace(/[?&]width=\d+/, (m) => m.replace(/\d+/, '2000'));

  //     images.push({
  //       src,
  //       alt: img.alt || ''
  //     });

  //   });

  //   return images;
  // }

  //NL custom code
  collectImagesFromSwiper() {
    const slides = document.querySelectorAll('.msw-main-slide');
    const images = [];
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        images.push({
          type: 'video',
          slideEl: slide
        });
        return;
      }
      const img = slide.querySelector('img');
      if (!img) return;
      images.push({
        type: 'image',
        src: img.currentSrc || img.src,
        alt: img.alt || '',
        slideEl: slide
      });
    });
    return images;
  }
  // NL custom code end

  // buildScrollContent() {
  //   this.scrollContainer.innerHTML = '';

  //   this.images.forEach((imgData, i) => {

  //     const item = document.createElement('div');
  //     item.className = 'pmz-item';
  //     item.dataset.index = i;

  //     item.innerHTML = `
  //       <img
  //         src="${imgData.src}"
  //         alt="${imgData.alt}"
  //         loading="${i <= this.currentIndex + 1 ? 'eager' : 'lazy'}"
  //       />
  //     `;

  //     this.scrollContainer.appendChild(item);
  //   });
  // }

  //NL custom code
  buildScrollContent() {
    this.scrollContainer.innerHTML = '';
    this.images.forEach((imgData, i) => {

      const item = document.createElement('div');
      item.className = 'pmz-item';
      item.dataset.index = i;
      const deferredMedia = imgData.slideEl?.querySelector('deferred-media');
      const mobileVideo = imgData.slideEl?.querySelector('video');
      if (deferredMedia) {
        item.innerHTML = deferredMedia.outerHTML;
      } else if (mobileVideo) {
        item.innerHTML = `
          <div class="pmz-video-wrapper">
            ${mobileVideo.outerHTML}
          </div>
        `;

      } else {
        item.innerHTML = `
          <img
            src="${imgData.src}"
            alt="${imgData.alt}"
            loading="${i <= this.currentIndex + 1 ? 'eager' : 'lazy'}"
          />
        `;
      }
      this.scrollContainer.appendChild(item);
    });
  }
  // NL custom code end

  open(index = 0) {
    this.currentIndex = index;

    this.buildScrollContent();

    this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;

    requestAnimationFrame(() => {
      this.overlay.classList.add('visible');

      const targetItem = this.scrollContainer.querySelectorAll('.pmz-item')[this.currentIndex];

      if (targetItem) {
        targetItem.scrollIntoView({
          block: 'start',
          behavior: 'instant'
        });
      }

      // NL mobile zoom video show
      this.scrollContainer.querySelectorAll('video').forEach(video => {
        video.muted = true;
        video.playsInline = true;

        const promise = video.play();

        if (promise) {
          promise.catch(() => {});
        }
      });
      // NL mobile zoom video show end

    });
  }

  close() {
    this.overlay.classList.remove('visible');

    setTimeout(() => {
      this.overlay.classList.remove('active');
      document.body.style.overflow = '';
      this.isOpen = false;
    }, 280);
  }

  /* --------------------------
     Click binding
  ---------------------------*/

  bindGalleryClicks() {

    document.addEventListener('click', (e) => {

      if (e.target.closest('.msw-thumb-slide')) return; // ignore thumbnail clicks
      if (e.target.closest('video, button, .splide__arrow, .splide__pagination')) return;

      /* Desktop gallery */

      const splideSlide = e.target.closest('.splide__slide.product-media-gallery__media');

      if (splideSlide) {

        const slides = [...document.querySelectorAll('.splide__slide.product-media-gallery__media')];
        const index = slides.indexOf(splideSlide);

        this.images = this.collectImages();
        if (!this.images.length) return;

        this.open(index);
        return;
      }

      /* Mobile main swiper */

      const mainSlide = e.target.closest('.msw-main-slide');

      if (mainSlide) {

        const slides = [...document.querySelectorAll('.msw-main-slide')];
        const index = slides.indexOf(mainSlide);

        this.images = this.collectImagesFromSwiper();
        if (!this.images.length) return;

        this.open(index);
      }

    });

  }

  /* --------------------------
     Cursor
  ---------------------------*/

  setCursor() {

    const applyCursor = () => {

      document.querySelectorAll(
        '.product-media-gallery__media img, .msw-main-slide img'
      ).forEach(img => {
        img.style.cursor = 'zoom-in';
      });

    };

    applyCursor();

    new MutationObserver(applyCursor).observe(document.body, {
      childList: true,
      subtree: true
    });

  }

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductMediaZoom());
} else {
  new ProductMediaZoom();
}